<!--
/*******************************************************************************
*@ 화면명     : MotpCertn
*@ 화면설명   :  mOTP PIN 인증  공통화면
*@ 사용전문   :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <NOSComponent ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <!--
      "MOTP-01-06-01-01": "mOTP PIN 번호인증",
      "MOTP-01-06-01-02": "등록하신 mOTP PIN 번호를 이용하여 인증을 합니다. <br />모바일 OTP 등록시 입력하셨던 mOTP PIN번호 6자리를 입력하세요."
    -->
    <div class="scroll">
      <contents-header
        :bg-type="true"
        :no-radius="true"
        title="MOTP-01-06-01-01"
        description="MOTP-01-06-01-02"
      />
      <div class="contents">
        <div class="cont-tit">
          <h6>{{ /*mOTP 정보*/ $t("MOTP-01-06-01-03") }}</h6>
        </div>
        <dl class="dlist dlist-item--type2">
          <dt>{{ /*아이디*/ $t("MOTP-01-06-01-04") }}</dt>
          <dd
            v-if="$store.state.sessionInfo.userInfo.userIdnfr !== ''"
          >{{ $store.state.sessionInfo.userInfo.userIdnfr }}</dd>
          <dt>{{ /*국가*/ $t("MOTP-01-06-01-05") }}</dt>
          <dd>{{ $t(`${$store.state.siteCode}_국가명`) }}</dd>
          <dt>{{ /*발급일*/ $t("MOTP-01-06-01-06") }}</dt>
          <dd>{{ $getGlobalDateYmd($store.state.auth.changeMotpPin.certnMotpId.out.success.issuncYMS) }}</dd>
        </dl>

        <form class="form">
          <div class="notice notice-box--type">
            <div class="notice-tit">
              <p class="bullet">{{ /*유의사항*/ $t("MOTP-01-06-01-07") }}</p>
            </div>
            <div class="notice-cont">
              <!-- 
                MOTP-01-06-01-08 : mOTP PIN번호를 잊어버린 경우
                MOTP-01-06-01-09 : mOTP PIN번호 분실 변경 메뉴를 통해서 다시 설정하실 수 있습니다. 
              -->
              <strong v-html="$t('MOTP-01-06-01-08')"></strong>
              <p v-html="$t('MOTP-01-06-01-09')"></p>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md normal" v-on:click="FN001">{{ /*인증하기*/ $t("MOTP-01-06-01-10") }}</button>
    </div>

    <!-- 메세지 -->
    <modal-pop
      :opened.sync="type3"
      :modal-header="true"
      :modal-footer="true"
      title="mOTP PIN를 잊어버린 경우"
      class="modal"
    >
      <template #content>
        <div>
          <!--모바일 OTP의 PIN번호를 분실하신 경우 mOTP PIN번호 분실 변경 메뉴를 통해서 다시 설정하실 수 있습니다.-->
          <span v-html="$t('MOTP-01-06-01-08')"></span>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="type3 = !type3">{{ /*취소*/ $t("MCOM-0000002") }}</button>
        <button
          class="btn bottom positive"
          @click="FN002"
        >{{ /*PIN번호 분실 변경*/ $t("MOTP-01-06-03-05") }}</button>
      </template>
    </modal-pop>

    <approval-line ref="approvalLine" :NOS_INSTANCE_REFERANCE="NOS_INSTANCE" />
  </article>
</template>
<style type="scss" scoped></style>
<script>
//import AppBar from "@/components/layout/AppBar";
// import ActionSheet from "@/components/modal/ActionSheet.vue";
import ModalPop from "@/components/modal/ModalPop.vue";
import { mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
//import ContentsHeader from "@/components/page/common/ContentsHeader.vue";
import Common from "@/components/basic/Common";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import ApprovalLine from "@/components/page/common/ApprovalLine";

export default {
  extends: Common,
  name: "MotpCertn",
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
  },
  components: {
    ModalPop,
    NOSComponent,
    ApprovalLine,
  },
  computed: {
    // 세션정보를 가져옴.
    ...mapFields(["sessionInfo", "siteCode"]),
    ...mapGetters("auth/changeMotpPin", ["getSSGenerateMotp", "getCertnMotpId"]),
  },
  async created() {
    // this.$store._mutations["auth/changeMotpPin/mut014"][0]({ key: "succFn", value: this.successFnc });
    // this.$store._mutations["auth/changeMotpPin/mut014"][0]({ key: "failFn", value: this.failFnc });
    // this.$store._mutations["auth/changeMotpPin/mut014"][0]({ key: "bizDscd", value: this.bizDscd });

    // // this.$log.info("motpid result--------->" + result);
    // // this.$log.info("sessionInfo-->", this.$store.state.sessionInfo);

    // // this.$log.info("mopt 생성 native SmphMchtlUniqNo------>", this.$store.state.native.smphMchtlUniqNo);
    // // this.$log.info("mopt 생성 DB SmphMchtlUniqNo------>", this.getCertnMotpId.out.success.SmphMchtlUniqNo);
    const result = await this.act018(); //motp정보
    if (result === "success") {
      // this.$bridge.SSInfogetMotp_motpCertn(); //기기정보 조회
      this.$log.info("mopt 정보------>", this.getCertnMotpId.out.success.issuncYMS);
    }
  },
  mounted() {
    this.NOS_INSTANCE.init();
  },
  data() {
    return {
      type: false,
      type2: false,
      type3: false,
      // error: false,
      motpNo: "",
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
    };
  },
  methods: {
    ...mapActions("auth/changeMotpPin", ["act018"]),

    // mopt 생성
    FN001: function () {
      const param = {
        bizDscd: this.bizDscd,
        commAuth: { biz: "01", bizParam: {} },
      };
      this.$post("/auth/motp/certn/CheckOTPLogin", param, this.FN003, this.FN004, function () {});
    },
    FN002: function () {
      this.type2 = false;
      this.$router.push({ name: "changeMotpPinStep1" });
    },
    FN003: function () {
      this.successFnc();
    },
    FN004: function () {
      this.failFnc();
    },
  },
};
</script>
